import { Container } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurColor, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const StyledSearchWrapper = styled.div<{ $navigationBarHeight: number }>`
    position: fixed;
    z-index: 2001;
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ $navigationBarHeight }) => $navigationBarHeight}px;
    top: 0;
    bottom: auto;
    left: 0;
    width: 100%;

    ${purpurMedia('lg')`
        position: absolute;
        bottom: 0;
        top: auto;
    `}
`;

export const StyledSearchContainer = styled(Container)`
    height: 100%;
    padding: 0;

    ${purpurMedia('lg')`
        padding: 0 var(--padding);
    `}
`;

export const StyledSearchContainerContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${getPurpurColor('brandWhite')};
    height: 100%;

    ${purpurMedia('lg')`
        margin-left: 6.25rem;
    `}
`;
